<template>
  <b-container fluid style="min-height: calc(100vh - 85px);">
    <NavBar>
      <template slot="right">
        <span></span>
      </template>
    </NavBar>
    <b-row>
      <b-col cols="12" lg="8" order="2" order-lg="1">
        <div class="mt-2">
        </div>
        <div class="ticket-header-container">
          <div class="ticket-title">
            <p class="d-none d-md-block">
              <span class="mr-1 text-dark">(#{{ ticket.id }})</span>
              <span>{{ ticket.title }}</span>
            </p>
            <p class="d-block d-md-none">
              <span class="mr-1 text-dark">(#{{ ticket.id }})</span>
              <span>{{ ticket.title }}</span>
            </p>
          </div>
          <div class="mt-3">
            <LinkifiedText :text="ticket.description" />
          </div>
        </div>
        <b-container fluid class="mt-3">
          <b-row class=" self-end">
            <b-col>
              <NewCommentInput
                :isDisabled="!canSubmitComment"
                :attachment="commentAttachment"
                @onNewComment="handleNewComment"
                @openFileSelector="handleCommentFileSelector"
                @removeAttachment="commentAttachment = null"
              />
            </b-col>
          </b-row>
          <div style="border-radius: 0.75rem; border: 1.5px solid #e2e8f0; margin-top: 12px;" />
          <b-row v-if="isAuthorized" class="mt-2" style="flex: 1; min-height: 200px">
            <b-col>
              <p class="fs-20 font-weight-bold mb-3 mt-2 text-center" style="line-height: 0.675rem; color: #163D7D;">
                <span class="d-none d-md-block fs-20">Comentarios</span>
                <!-- <span class="d-block d-md-none">Comentarios</span> -->
              </p>
              <div>
                <ol style="padding-left: 0;">
                  <li v-for="comment in comments" :key="comment.id" style="list-style: none;">
                    <Comment
                      :comment="comment"
                      :agentId="ticket.agent_id"
                      :userId="ticket.user_id"
                      :followersIds="followers.map(follower => follower.id)"
                      @showFullImage="showFullImage"
                    />
                  </li>
                </ol>
                <div v-if="comments.length === 0" class="d-flex justify-content-center align-items-center" style="height: 100%; min-height: 200px">
                  <span class="fs-18 m-0 text-muted">
                    No hay comentarios aún
                  </span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row v-else class="mt-2" style="min-height: 200px">
            <b-col>
              <div v-if="loading" class="d-flex justify-content-center align-items-center text-info" style="height: 100%;">
                <b-spinner style="width: 1.25rem; height: 1.25rem" type="grow"></b-spinner>
                <span class="pl-2 fs-18">Cargando</span>
              </div>
              <div v-else class="d-flex justify-content-center align-items-center" style="height: 100%;">
                <span class="fs-20 m-0 text-muted">
                  <font-awesome-icon :icon="['far', 'info-circle']" fixed-width />
                  <span>No tiene permisos para ver este ticket</span>
                </span>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
      <b-col cols="12" lg="4" order="1" order-lg="2">
        <ShowAside
          :ticket="ticket"
          :followers="followers"
          :attachments="attachments"
          :canEditDetails="canEditDetails"
          :canAddAttachments="canAddAttachments"
          :canManageFollowers="canManageFollowers"
          @updateTicket="updateTicket"
          @toggle-attachments-modal="handleTicketFileSelector"
          @showFullImage="showFullImage"
          @remove-follower="removeStateFollower"
          @add-follower="addFollower"
        />
      </b-col>
    </b-row>

    <!-- Attachments Modal -->
    <Modal
      v-if="attachmentsModalShow"
      contentWidth="500px"
      :required=true
      @close="closeAttachmentsModal"
    >
      <template #header>
        <p class="fs-20 font-weight-bold ml-1 mb-0" style="line-height: 0.675rem; color: #163D7D;">
          {{  attachmentsModalTitle }}
        </p>
      </template>
      <template #body>
        <b-row>
          <b-col>
            <AttachmentsUploader
              :allowedFileTypes="allowedFileTypes"
              :maxNumberOfFiles="attachmentsMaxFiles"
              :maxFileSize="10485760"
              :useDashboard="true"
              @file-added="handleFileAdded"
              @file-removed="handleFileRemoved"
              @handle-done-button="closeAttachmentsModal"
            />
          </b-col>
        </b-row>
      </template>
      <template #footer>
        <span></span>
      </template>
    </Modal>

    <!-- Full image modal -->
    <ImageFullModal
      v-if="fullImageUrl"
      :image-url="fullImageUrl"
      :disableControls="true"
      @close-modal="fullImageUrl = null"
    />

    <!-- Alert -->
    <ToastAlert :show="alertShow" :variant="alertVariant" @close="alertShow = false">
      {{ alertMessage }}
    </ToastAlert>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import { normalize, schema } from 'normalizr'

import ToastAlert from '../../shared/ToastAlert'
import Comment from './Comment.vue';
import ShowAside from './ShowAside.vue';
import NavBar from './NavBar.vue';
import NewCommentInput from './NewCommentInput.vue';
import AttachmentsUploader from '../../shared/AttachmentsUploader.vue'
import Modal from '../../shared/Modal'
import ImageFullModal from '../../shared/ImageFullModal'
import { allowedFileTypes } from '../../../sharedOptions/ticketsModule'
import LinkifiedText from '../../shared/LinkifiedText.vue'

export default {
  name: 'Show',
  components: { NavBar, ShowAside, NewCommentInput, Comment, ToastAlert, AttachmentsUploader, Modal, ImageFullModal, LinkifiedText },
  data () {
    return {
      id: this.$route.params.id,
      loading: false,
      ticket: {},
      commentData: {},
      commentList: [],
      documentData: {},
      documentList: [],
      photoData: {},
      photoList: [],
      closeStatusMap: ['resuelto', 'desestimado', 'pasa_a_proyecto'],
      alertShow: false,
      alertVariant: null,
      alertMessage: '',
      attachmentsModalShow: false,
      attachmentsOrigen: 'ticket',
      attachmentsMaxFiles: 5,
      commentAttachment: null,
      fullImageUrl: null,
      followers: [],
      allowedFileTypes: allowedFileTypes
    }
  },
  mounted () {
    this.fetchTicket()
  },
  computed: {
    ...mapState({
      currentUser: state => state.currentUser
    }),
    comments () {
      return this.commentList.map(id => this.commentData[id])
                             .sort((a, b) => a.created_at > b.created_at ? -1 : 1)
    },
    attachments () {
      const documents = this.documentList.map(id => ({...this.documentData[id], type: 'document', file_id: '', origen: 'ticket'}))
      const photos = this.photoList.map(id => ({...this.photoData[id], type: 'photo', file_id: '', origen: 'ticket'}))
      const notesDocuments = this.commentList.map(id => this.commentData[id]).filter(comment => comment.document?.id).map(comment => ({...comment.document, type: 'document', file_id: '', origen: 'comment'}))
      const notesPhotos = this.commentList.map(id => this.commentData[id]).filter(comment => comment.photo?.id).map(comment => ({...comment.photo, type: 'photo', file_id: '', origen: 'comment'}))

      const attachments = documents.concat(photos).concat(notesDocuments).concat(notesPhotos)
      return attachments.sort((a, b) => a.created_at > b.created_at ? -1 : 1)
    },
    isAuthorized () {
      if (!this.ticket.id) return false

      const isTicketAgent = this.currentUser.id === this.ticket.agent_id
      const isTicketSender = this.currentUser.id === this.ticket.user_id
      const isTicketFollower = this.followers.find(f => f.id === this.currentUser.id)

      return isTicketAgent || isTicketSender || isTicketFollower
    },
    canSubmitComment () {
      if (!this.isAuthorized) return false

      return true
    },
    canEditDetails () {
      if (!this.isAuthorized) return false

      return this.currentUser.id === this.ticket.agent_id
    },
    canManageFollowers () {
      if (!this.isAuthorized) return false

      return this.currentUser.id === this.ticket.agent_id || this.currentUser.id === this.ticket.user_id
    },
    canAddAttachments () {
      if (!this.isAuthorized) return false

      // if closed ticket, only agent can add attachments
      const isAgent = this.currentUser.id === this.ticket.agent_id
      if (this.closeStatusMap.includes(this.ticket.status)) return isAgent

      return true
    },
    attachmentsModalTitle () {
      if (!this.attachmentsModalShow) return ''

      return this.attachmentsOrigen == 'ticket' ? 'Adjuntar archivos al ticket' : 'Adjuntar archivo al comentario'
    }
  },
  methods: {
    fetchTicket () {
      if (!this.id) { return }
      if (this.loading) { return }

      this.loading = true
      this.$http.get(`/api/production/internal_tickets/${this.id}`)
        .then(response => {
          this.ticket = response.data
          this.formatComments(this.ticket.internal_ticket_notes)
          this.formatAttachments(this.ticket.documents, this.ticket.photos)
          this.followers = this.ticket.followers

          delete this.ticket['internal_ticket_notes']
          delete this.ticket['photos']
          delete this.ticket['documents']
          delete this.ticket['followers']
        })
        .catch(error => {
          // console.log(error)
        })
        .finally(() => this.loading = false)
    },
    normalizeData (items) {
      const normalized = normalize(
        { items },
        { items: [new schema.Entity('items')] }
      )

      return {
        data: normalized.entities.items || {},
        list: normalized.result.items
      }
    },
    formatComments (comments) {
      const { data: commentData, list: commentList } = this.normalizeData(comments)
      this.commentData = commentData
      this.commentList = commentList
    },
    formatAttachments (documents, photos) {
      const { data: documentData, list: documentList } = this.normalizeData(documents)
      const { data: photoData, list: photoList } = this.normalizeData(photos)


      this.documentData = documentData
      this.documentList = documentList

      this.photoData = photoData
      this.photoList = photoList
    },
    updateTicket (form) {
      if (this.processing) { return }
      this.processing = true

      const previousStatus = this.ticket.status

      this.$http.patch(`/api/production/internal_tickets/${this.id}`, {
          internal_ticket: {
            ...form
          }
        })
        .then(response => {
          const newStatus = response.data.status
          this.ticket = response.data

          let message = 'Ticket actualizado correctamente'

          if (previousStatus !== 'pendiente_aprobacion_cliente' && newStatus === 'pendiente_aprobacion_cliente') {
            message = 'Se ha notificado al usuario para que valide la solución'
          } else if (!Object.hasOwn(form, 'status')) {
            message = 'El agente se ha actualizado correctamente'
          }

          this.displayAlert({ message: message, variant: 'success' })
        })
        .catch(error => {
          this.displayAlert({ message: 'Ocurrió un error al actualizar el ticket, intente nuevamente', variant: 'danger' })
        })
        .finally(() => this.processing = false)
    },
    handleNewComment (response) {
      const { note, ticket } = response

      this.commentData[note.id] = note
      this.commentList.unshift(note.id)
      this.commentAttachment = null

      this.ticket.updated_at = ticket.updated_at
      this.ticket.status = ticket.status
    },
    displayAlert ({ message, variant, time=2000 }) {
      this.alertVariant = variant
      this.alertMessage = message
      this.alertShow = true

      setTimeout(() => this.alertShow = false, time)
    },
    handleTicketFileSelector () {
      this.attachmentsMaxFiles = 5
      this.attachmentsOrigen = 'ticket'
      this.attachmentsModalShow = true
    },
    handleCommentFileSelector () {
      this.attachmentsMaxFiles = 1
      this.attachmentsOrigen = 'comment'
      this.attachmentsModalShow = true
    },
    closeAttachmentsModal () {
      this.attachmentsModalShow = false
      this.attachmentsOrigen = 'ticket'
      this.attachmentsMaxFiles = 5
    },
    handleFileAdded (form) {
      if (this.attachmentsOrigen === 'ticket') {
        this.addTicketFile(form)
      } else if (this.attachmentsOrigen === 'comment') {
        this.commentAttachment = form // save temp file
        this.attachmentsModalShow = false
        this.displayAlert({ message: 'Archivo agregado correctamente', variant: 'success' })
      }
    },
    addTicketFile (form) {
      if (this.processing) { return }
      this.processing = true
      const resource = form.type == 'image' ? 'photos' : 'documents'
      const body = form.type == 'image' ? { photo: { image: form.image, caption: form.caption } } : { document: { file: form.file, name: form.name } }

      this.$http.post(`/api/production/internal_tickets/${this.ticket.id}/${resource}`, body)
        .then((res) => {
          // console.log(res.data)
          if (resource === 'photos') {
            const photo = res.data.photo
            photo.type = 'photo'
            photo.file_id = form.file_id
            photo.img_url_lg = form.preview

            this.photoData[photo.id] = photo
            this.photoList.unshift(photo.id)
          } else {
            const document = res.data.document
            document.file_id = form.file_id
            document.type = 'document'

            this.documentData[document.id] = document
            this.documentList.unshift(document.id)
          }
        })
        .catch(e => {
          // console.log(e)
          const fileName = resource == 'photos' ? form.caption : form.name
          this.displayAlert({
            message: `No fue posible agregar el archivo: "${fileName}"`,
            variant: 'danger',
            time: 4000
          })
        })
        .finally(this.processing = false)
    },
    handleFileRemoved (file) {
      if (this.attachmentsOrigen === 'ticket') {
        this.removeTicketFile(file)
      } else if (this.attachmentsOrigen === 'comment') {
        this.commentAttachment = null
      }

      return
    },
    removeTicketFile (file) {
      const resource = file.type == 'image' ? 'photos' : 'documents'
      let localFile = {}

      if (file.type == 'image') {
        localFile = this.photoList.map(id => this.photoData[id]).find(p => p?.file_id === file.file_id) || {}
        if (!localFile.id) return
      } else {
        localFile = this.documentList.map(id => this.documentData[id]).find(p => p.file_id === file.file_id) || {}
        if (!localFile.id) return
      }

      if (this.processing) return
      this.processing = true

      this.$http.delete(`/api/production/internal_tickets/${this.ticket.id}/${resource}/${localFile.id}`)
        .then((resp) => {
          if (resource === 'photos') {
            delete this.photoData[localFile.id]
            this.photoList = this.photoList.filter(id => id !== localFile.id)
          } else {
            delete this.documentData[localFile.id]
            this.documentList = this.documentList.filter(id => id !== localFile.id)
          }
        })
        .catch(e => {
          // console.log(e)
        })
        .finally(()=> {
          this.processing = false
        })
    },
    showFullImage (imageUrl) {
      this.fullImageUrl = imageUrl
    },
    removeStateFollower (id) {
      const followerIndex = this.followers.findIndex(follower => follower.id === id)
      if (followerIndex === -1) return

      this.followers.splice(followerIndex, 1)
    },
    addFollower (user) {
      this.followers.push(user)
    }
  }
}
</script>

<style scoped>
.ticket-header-container {
  display: flex;
  flex-direction: column;
  padding: 0 1rem 0.5rem 1rem;
}

.ticket-title p {
  color: #163D7D;
  font-size: 20px;
  line-height: 23px;
  font-weight: 700;
  text-align: left;
  margin-bottom: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

@media (max-width: 767px) {
  .ticket-title p {
    font-size: 18px;
  }
}

</style>
